import { render, staticRenderFns } from "./VacationCalendarComponent.vue?vue&type=template&id=24b12685&scoped=true&"
import script from "./VacationCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./VacationCalendarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b12685",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b12685')) {
      api.createRecord('24b12685', component.options)
    } else {
      api.reload('24b12685', component.options)
    }
    module.hot.accept("./VacationCalendarComponent.vue?vue&type=template&id=24b12685&scoped=true&", function () {
      api.rerender('24b12685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/vacations/components/VacationCalendarComponent.vue"
export default component.exports